import React from "react";
import DashboardFrame from "../../component/dashboard-frame";
import { useAppDispatch } from "../../redux/store";
import { deleteAppThunk } from "../../redux/thunks/app.thunk";
import AppTile from "../../component/user-app/user-app";
import SearchApp from "../../component/user-app/search-app";

const AddApp = () => {
  const dispatch = useAppDispatch();

  const deleteHandler = (id: string) => {
    dispatch(deleteAppThunk(id));
  };

  return (
    <DashboardFrame title="App">
      <SearchApp title="Add The App Want To Promote" paper>
        <AppTile deleteHandler={deleteHandler} />
      </SearchApp>
    </DashboardFrame>
  );
};

export default AddApp;
